import Vue from 'vue'
import VueRouter from 'vue-router'

import HelpCenter from '../views/help/Center.vue'

import AuthCenter from '../views/auth/Center.vue'
import BuyCenter from '../views/buy/Center.vue'
import BuyPay from '../views/buy/Pay.vue'
import FeedbookCenter from '../views/feedbook/Center.vue'
import CodesCenter from '../views/codes/Center.vue'


import AgentConfirm from '../views/agent/Confirm.vue'
import AgentCenter from '../views/agent/Center.vue'


import MemberCenter from '../views/member/Center.vue'
import MemberLogin from '../views/member/Login.vue'
import MemberAddGroup from '../views/member/AddGroup.vue'
import GroupDisplay from '../views/group/Display.vue'
import GroupCenter from '../views/group/Center.vue'

import GroupResur from '../views/group/Resur.vue'

import GroupSrcSet from '../views/group/src/Set.vue'
import GroupSrcChat from '../views/group/src/Chat.vue'
import GroupSrcMusic from '../views/group/src/Music.vue'
import GroupSrcWelcome from '../views/group/src/Welcome.vue'
import GroupSrcOutMessage from '../views/group/src/OutMessage.vue'
import GroupSrcUsers from '../views/group/src/Users.vue'
import GroupSrcWeather from '../views/group/src/Weather.vue'
import GroupSrcSign from '../views/group/src/Sign.vue'

import GroupSrcCalc from '../views/group/src/Calc.vue'

import GroupSrcText from '../views/group/src/Text.vue'
import GroupSrcImage from '../views/group/src/Image.vue'
import GroupSrcIdCard from '../views/group/src/IdCard.vue'
import GroupSrcLink from '../views/group/src/Link.vue'
import GroupSrcMini from '../views/group/src/Mini.vue'
import GroupSrcInvita from '../views/group/src/Invita.vue'

import GroupSrcASet from '../views/group/src/ASet.vue'
import GroupSrcAAite from '../views/group/src/AAite.vue'
import GroupSrcAKeyword from '../views/group/src/AKeyword.vue'
import GroupSrcAIdCard from '../views/group/src/AIdCard.vue'
import GroupSrcALink from '../views/group/src/ALink.vue'
import GroupSrcAMini from '../views/group/src/AMini.vue'

import GroupSrcCaiTuPian from '../views/group/src/CaiTuPian.vue'
import GroupSrcChengYuJieLong from '../views/group/src/ChengYuJieLong.vue'
import GroupSrcCaiGeMing from '../views/group/src/CaiGeMing.vue'
import GroupSrcZhaoCha from '../views/group/src/ZhaoCha.vue'
import GroupSrcCaiWangZheYingXiong from '../views/group/src/CaiWangZheYingXiong.vue'
import GroupSrcNuoJiYa from '../views/group/src/NuoJiYa.vue'
import GroupSrcDaJie from '../views/group/src/DaJie.vue'
import GroupSrcLiwu from '../views/group/src/Liwu.vue'

Vue.use(VueRouter)
const routes = [{
	path: '/auth-center',
	component: AuthCenter,
	meta: {
		keepAlive: true,
		index: 2
	}
}, {
	path: '/',
	component: BuyCenter,
	meta: {
		bar: true,
		keepAlive: true
	}
}, {
	path: '/channel-:channel_id',
	component: BuyCenter,
	meta: {
		bar: true,
		keepAlive: true
	}
}, {
	path: '/pay-:str',
	component: BuyPay
}, {
	path: '/feedbook-center',
	component: FeedbookCenter,
	meta: {
		keepAlive: true
	}
}, {
	path: '/agent-confirm',
	component: AgentConfirm
}, {
	path: '/agent-center',
	component: AgentCenter
}, {
	path: '/codes-center',
	component: CodesCenter,
	meta: {
		keepAlive: true
	}
}, {
	path: '/help-center',
	component: HelpCenter,
	meta: {
		bar: true,
		keepAlive: true
	}
}, {
	path: '/member-center',
	component: MemberCenter,
	meta: {
		bar: true,
		keepAlive: false
	}
}, {
	path: '/member-login',
	component: MemberLogin
}, {
	path: '/member-addGroup',
	component: MemberAddGroup
}, {
	path: '/group-display-:id',
	component: GroupDisplay
}, {
	path: '/group-center',
	component: GroupCenter,
	meta: {
		keepAlive: true
	}
}, {
	path: '/group-resur-:id',
	component: GroupResur
}, {
	path: '/group-src-set',
	component: GroupSrcSet
}, {
	path: '/group-src-chat',
	component: GroupSrcChat
}, {
	path: '/group-src-music',
	component: GroupSrcMusic
}, {
	path: '/group-src-welcome',
	component: GroupSrcWelcome
}, {
	path: '/group-src-outmessage',
	component: GroupSrcOutMessage
}, {
	path: '/group-src-users',
	component: GroupSrcUsers
}, {
	path: '/group-src-weather',
	component: GroupSrcWeather
}, {
	path: '/group-src-sign',
	component: GroupSrcSign
}, {
	path: '/group-src-calc',
	component: GroupSrcCalc
}, {
	path: '/group-src-text',
	component: GroupSrcText
}, {
	path: '/group-src-image',
	component: GroupSrcImage
}, {
	path: '/group-src-idcard',
	component: GroupSrcIdCard
}, {
	path: '/group-src-link',
	component: GroupSrcLink
}, {
	path: '/group-src-mini',
	component: GroupSrcMini
}, {
	path: '/group-src-invita',
	component: GroupSrcInvita
}, {
	path: '/group-src-aset',
	component: GroupSrcASet
}, {
	path: '/group-src-aaite',
	component: GroupSrcAAite
}, {
	path: '/group-src-akeyword',
	component: GroupSrcAKeyword
}, {
	path: '/group-src-aidcard',
	component: GroupSrcAIdCard
}, {
	path: '/group-src-alink',
	component: GroupSrcALink
}, {
	path: '/group-src-amini',
	component: GroupSrcAMini
}, {
	path: '/group-src-ctp',
	component: GroupSrcCaiTuPian
}, {
	path: '/group-src-cyjl',
	component: GroupSrcChengYuJieLong
}, {
	path: '/group-src-cgm',
	component: GroupSrcCaiGeMing
}, {
	path: '/group-src-zc',
	component: GroupSrcZhaoCha
}, {
	path: '/group-src-cwzyx',
	component: GroupSrcCaiWangZheYingXiong
}, {
	path: '/group-src-njy',
	component: GroupSrcNuoJiYa
}, {
	path: '/group-src-dj',
	component: GroupSrcDaJie
}, {
	path: '/group-src-lw',
	component: GroupSrcLiwu
}, {
	path: '*',
	redirect: '/'
}]

const router = new VueRouter({
	mode: 'history',
	routes
})

export default router
